import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicNetworkLoadBalancerCreateParamsI,
	LWApiPublicNetworkLoadBalancerCreateResultI,
} from '@liquidweb-dev/club-sauce/public/network/loadbalancer/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { ASSET_LIST_QUERY_KEY } from 'modules/queries/asset/useList';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useCreateLoadBalancer = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicNetworkLoadBalancerCreateResultI,
		ApiErrorI,
		LWApiPublicNetworkLoadBalancerCreateParamsI
	>({
		mutationFn: (params) => api.network.loadbalancer.apiRaw.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [ASSET_LIST_QUERY_KEY],
			});

			toast.success('Successfully created load balancer');
		},
		onError: snackbarError,
	});
};

export default useCreateLoadBalancer;
